module.exports = __webpack_public_path__ + "static/media/pause.539b0942.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pause.svg
// module id = 227
// module chunks = 0